import { useTranslation } from '../../i18n/hooks/useTranslation';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useTranslation();
  const isBn = currentLanguage === 'bn';

  const toggle = () => changeLanguage(isBn ? 'en' : 'bn');

  return (
    <button
      type="button"
      onClick={toggle}
      className="inline-flex items-center h-6 rounded-md border border-zinc-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 font-semibold focus:outline-none cursor-pointer p-0.5 gap-0.5"
      style={{ fontSize: 10 }}
      title={isBn ? 'Switch to English' : 'বাংলায় পরিবর্তন করুন'}
    >
      <span className={`flex items-center px-1.5 h-full rounded transition-colors ${!isBn ? 'bg-primary text-white' : 'text-zinc-500 dark:text-zinc-400'}`}>
        EN
      </span>
      <span className={`flex items-center px-1.5 h-full rounded transition-colors ${isBn ? 'bg-primary text-white' : 'text-zinc-500 dark:text-zinc-400'}`}>
        বাং
      </span>
    </button>
  );
};

export default LanguageSwitcher;
